<template>
  <div class="user-management-item-layout">
    <v-row class="user-management-prompt-wrapper-root">
      <v-col cols="6" class="image">
        <v-img contain :src="require('./assets/user-management.svg')" :aspect-ratio="4 / 2" />
      </v-col>
      <v-col class="user-management-prompt-wrapper">
        <div class="header">
          {{ $t(userManagementData.header) }}
        </div>
        <div class="content">
          <p>{{ $t(userManagementData.content) }}</p>
          <br>
          <p>
            <a target="_blank" :href="linkToAdminConsole()" rel="noopener noreferrer">
              {{ $t(userManagementData.link.text) }}
            </a>
          </p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import './styles/user-management-item.scss';
import userManager from '@/auth';

@Component
export default class UserManagementItem extends Vue {
  private get userManagementData() {
    return {
      header: 'access.user_list.title',
      content: 'access.user_list.subtitle',
      idToken: userManager.getIdToken(),
      link: {
        text: 'access.user_list.link'
      }
    };
  }

  private linkToAdminConsole() {
    const server = config.VUE_APP_USER_MANAGEMENT_SERVER || process.env.VUE_APP_USER_MANAGEMENT_SERVER;
    const destination = config.VUE_APP_USER_MANAGEMENT_DESTINATION || process.env.VUE_APP_USER_MANAGEMENT_DESTINATION;
    return `https://${server}?destination=${encodeURIComponent(destination)}&id_token=${this.userManagementData.idToken}`;
  }
}
</script>
